import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from './../utils/route-guard/AuthGuard';

import AdministrationCenter from '../views/pages/authentication/configuracoes/geral/Administracao.js';


import ViewAllProducts from '../views/pages/authentication/configuracoes/Products/ViewAllProducts.js';
import ViewProduct from '../views/pages/authentication/configuracoes/Products/ViewProduct.js';
import EditProduct from '../views/pages/authentication/configuracoes/Products/EditProduct.js';
import CreateProduct from '../views/pages/authentication/configuracoes/Products/CreateProduct.js';
import ProductCategories from '../views/pages/authentication/configuracoes/Products/Categories.js';
import ProductBrands from '../views/pages/authentication/configuracoes/Products/Brands.js';
import ProductModels from '../views/pages/authentication/configuracoes/Products/ProductModels.js';
import ViewAllServices from '../views/pages/authentication/configuracoes/services/ViewAllServices.js';
import ServiceForm from '../views/pages/authentication/configuracoes/services/ServiceForm.js';
import ServiceCategories from '../views/pages/authentication/configuracoes/services/ServiceCategories.js';

import Vendas from '../views/pages/authentication/configuracoes/vendas/index.js';
import DetalheVenda from '../views/pages/authentication/configuracoes/vendas/DetalheVenda.js';

import ViewAllSalesOrders from '../views/pages/authentication/configuracoes/sales/ViewAllSalesOrders.js';
import CreateSalesOrder from '../views/pages/authentication/configuracoes/sales/CreateSalesOrder.js';
import ViewSalesOrder from '../views/pages/authentication/configuracoes/sales/ViewSalesOrder.js';
import ViewAllSalesQuotes from '../views/pages/authentication/configuracoes/sales/ViewAllSalesQuotes.js';
import CreateSalesQuote from '../views/pages/authentication/configuracoes/sales/CreateSalesQuote.js';
import ViewSalesQuote from '../views/pages/authentication/configuracoes/sales/ViewSalesQuote.js';
import PriceTables from '../views/pages/authentication/configuracoes/sales/PriceTables.js';

import ViewAllPurchaseOrders from '../views/pages/authentication/configuracoes/purchasing/ViewAllPurchaseOrders.js';
import CreatePurchaseOrder from '../views/pages/authentication/configuracoes/purchasing/CreatePurchaseOrder.js';
import ViewPurchaseOrder from '../views/pages/authentication/configuracoes/purchasing/ViewPurchaseOrder.js';
import ViewAllPurchaseRequests from '../views/pages/authentication/configuracoes/purchasing/ViewAllPurchaseRequests.js';
import CreatePurchaseRequest from '../views/pages/authentication/configuracoes/purchasing/CreatePurchaseRequest.js';
import ViewPurchaseRequest from '../views/pages/authentication/configuracoes/purchasing/ViewPurchaseRequest.js';
import ViewPurchaseQuotation from '../views/pages/authentication/configuracoes/purchasing/ViewPurchaseQuotation.js';

import StockPosition from '../views/pages/authentication/configuracoes/inventory/StockPosition.js';
import StockMovements from '../views/pages/authentication/configuracoes/inventory/StockMovements.js';
import CreateStockMovement from '../views/pages/authentication/configuracoes/inventory/CreateStockMovement.js';
import StockTransfers from '../views/pages/authentication/configuracoes/inventory/StockTransfers.js';
import Warehouses from '../views/pages/authentication/configuracoes/inventory/Warehouses.js';
import WarehouseLocations from '../views/pages/authentication/configuracoes/inventory/WarehouseLocations.js';
import LotsAndSerials from '../views/pages/authentication/configuracoes/inventory/LotsAndSerials.js';
import Kardex from '../views/pages/authentication/configuracoes/inventory/Kardex.js';

import ViewAllAccountsPayable from '../views/pages/authentication/configuracoes/financial/ViewAllAccountsPayable.js';
import AccountPayableForm from '../views/pages/authentication/configuracoes/financial/AccountPayableForm.js';
import ViewAllAccountsReceivable from '../views/pages/authentication/configuracoes/financial/ViewAllAccountsReceivable.js';
import AccountReceivableForm from '../views/pages/authentication/configuracoes/financial/AccountReceivableForm.js';
import CashFlow from '../views/pages/authentication/configuracoes/financial/CashFlow.js';
import FinancialDashboard from '../views/pages/authentication/configuracoes/financial/FinancialDashboard.js';
import BankAccounts from '../views/pages/authentication/configuracoes/financial/BankAccounts.js';
import BankReconciliation from '../views/pages/authentication/configuracoes/financial/BankReconciliation.js';
import CollectionRules from '../views/pages/authentication/configuracoes/financial/CollectionRules.js';
import Departments from '../views/pages/authentication/configuracoes/hr/Departments.js';
import Roles from '../views/pages/authentication/configuracoes/hr/Roles.js';
import ViewAllColaboradores from '../views/pages/authentication/configuracoes/hr/ViewAllColaboradores.js';
import ColaboradorForm from '../views/pages/authentication/configuracoes/hr/ColaboradorForm.js';
import LeaveRequests from '../views/pages/authentication/configuracoes/hr/LeaveRequests.js';
import PayrollRuns from '../views/pages/authentication/configuracoes/hr/PayrollRuns.js';
import PayrollRunDetail from '../views/pages/authentication/configuracoes/hr/PayrollRunDetail.js';
import BillOfMaterialsList from '../views/pages/authentication/configuracoes/production/BillOfMaterialsList.js';
import CreateBillOfMaterials from '../views/pages/authentication/configuracoes/production/CreateBillOfMaterials.js';
import ProductionOrders from '../views/pages/authentication/configuracoes/production/ProductionOrders.js';
import ProductionOrderDetail from '../views/pages/authentication/configuracoes/production/ProductionOrderDetail.js';

import ReportsHome from '../views/pages/authentication/configuracoes/reports/ReportsHome.js';
import SalesReport from '../views/pages/authentication/configuracoes/reports/SalesReport.js';
import PurchasingReport from '../views/pages/authentication/configuracoes/reports/PurchasingReport.js';
import FinancialAgingReport from '../views/pages/authentication/configuracoes/reports/FinancialAgingReport.js';
import InventoryValuationReport from '../views/pages/authentication/configuracoes/reports/InventoryValuationReport.js';

import EstablishmentForm from '../views/pages/authentication/configuracoes/establishments/EstablishmentForm.js';


import SystemUsers from '../views/pages/authentication/configuracoes/users/UsersSystem.js';

import SystemNotifications from '../views/pages/authentication/configuracoes/notifications/AdminNotification.js';

import ViewUsers from '../views/pages/authentication/configuracoes/users/ViewUsers.js';
import CreateUser from '../views/pages/authentication/configuracoes/users/CreateUser.js';
import EditUser from '../views/pages/authentication/configuracoes/users/EditUser.js';

import CreateOrganization from '../views/pages/authentication/configuracoes/organizations/CreateOrganization.js';
import ViewOrganization from '../views/pages/authentication/configuracoes/organizations/ViewOrganization.js';
import EditOrganization from '../views/pages/authentication/configuracoes/organizations/EditOrganization.js';
import ViewSuppliers from '../views/pages/authentication/configuracoes/organizations/ViewSuppliers.js';
import CreateCompany from '../views/pages/authentication/configuracoes/companies/CreateCompany.js';
import ViewCompanies from '../views/pages/authentication/configuracoes/companies/ViewCompanies.js';
import EditCompany from '../views/pages/authentication/configuracoes/companies/EditCompany.js';
import BranchForm from '../views/pages/authentication/configuracoes/companies/BranchForm.js';
import ReferencesHome from '../views/pages/authentication/configuracoes/references/ReferencesHome.js';
import UnitsOfMeasure from '../views/pages/authentication/configuracoes/references/UnitsOfMeasure.js';
import Currencies from '../views/pages/authentication/configuracoes/references/Currencies.js';
import Banks from '../views/pages/authentication/configuracoes/references/Banks.js';
import Agencies from '../views/pages/authentication/configuracoes/references/Agencies.js';
import PaymentMethods from '../views/pages/authentication/configuracoes/references/PaymentMethods.js';
import PaymentTerms from '../views/pages/authentication/configuracoes/references/PaymentTerms.js';
import CostCenters from '../views/pages/authentication/configuracoes/references/CostCenters.js';
import FinancialCategories from '../views/pages/authentication/configuracoes/references/FinancialCategories.js';
import Countries from '../views/pages/authentication/configuracoes/references/Countries.js';
import States from '../views/pages/authentication/configuracoes/references/States.js';
import Cities from '../views/pages/authentication/configuracoes/references/Cities.js';


import SettingsControl from '../views/pages/authentication/configuracoes/index.js';
import Customization from '../layout/Customization/index.js';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('../views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('../views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('../views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('../views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('../views/utilities/TablerIcons')));

const Customizacao = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Customizacao/AjusteCustomizacao.js')));
const CustomFields = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/geral/CustomFields.js')));
const CalendarPage = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/Calendar/CalendarPage.js')));

const AiChat = Loadable(lazy(() => import('../views/pages/authentication/chat_ia/index.js')));

const Reports = Loadable(lazy(() => import('../views/pages/authentication/configuracoes/relatorios/VisualizarRelatorios.js')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/sample-page')));

//-----------------------|| MAIN ROUTING ||-----------------------//
const MainRoutes = () => {
    const location = useLocation();

    return (
        <Route
            path={[
                '/home',

                '/adm/config/',

                '/utils/util-typography',
                '/utils/util-color',
                '/utils/util-shadow',
                '/icons/tabler-icons',
                '/icons/material-icons',

                '/dashboard/admin/users',

                '/dashboard/admin/notifications',

                '/dashboard/config/products',
                '/dashboard/config/product',
                '/dashboard/config/product/edit',
                '/dashboard/config/new/product',

                '/dashboard/config/services',

                '/dashboard/orders',
                '/dashboard/detailsorder',

                '/dashboard/sales',
                '/dashboard/purchasing',
                '/dashboard/inventory',
                '/dashboard/financial',
                '/dashboard/hr',
                '/dashboard/production',
                '/dashboard/reports',
                '/dashboard/establishments',


                '/dashboard/config/organizations/create',
                '/dashboard/config/organizations/view',
                '/dashboard/config/suppliers',
                '/dashboard/config/organizations/edit',

                '/dashboard/config/companies/create',
                '/dashboard/config/companies/view',
                '/dashboard/config/companies/edit',
                '/dashboard/config/companies/branches',

                '/dashboard/config/references',

                '/dashboard/config/users/create',
                '/dashboard/config/users/view',
                '/dashboard/config/users/edit',

                '/dashboard/config/calendar',

                '/dashboard/chats/panel/ia',

                '/utils/util-report',

                '/dashboard/config/index/',

                '/dashboard/config/custom',
                '/dashboard/config/custom-fields',

                '/dashboard/panel/',

                '/sample-page'
            ]}
        >
            <MainLayout>
                <Switch location={location} key={location.pathname}>
                    <AuthGuard>
                        <Route path="/home" component={DashboardDefault} />
                        <Route path="/utils/util-typography" component={UtilsTypography} />
                        <Route path="/utils/util-color" component={UtilsColor} />
                        <Route path="/utils/util-shadow" component={UtilsShadow} />
                        <Route path="/icons/tabler-icons" component={UtilsTablerIcons} />
                        <Route path="/icons/material-icons" component={UtilsMaterialIcons} />
                        <Route path="/adm/config/" component={AdministrationCenter} />

                        <Route path="/dashboard/admin/notifications" component={SystemNotifications} />

                        {/* IA */}
                        <Route path="/dashboard/chats/panel/ia" component={AiChat} />

                        {/* PRODUTOS */}
                        <Route exact path="/dashboard/config/products" component={ViewAllProducts} />
                        <Route path="/dashboard/config/products/categories" component={ProductCategories} />
                        <Route path="/dashboard/config/products/brands" component={ProductBrands} />
                        <Route path="/dashboard/config/products/models" component={ProductModels} />
                        <Route path="/dashboard/config/product/edit/:id" component={EditProduct} />
                        <Route exact path="/dashboard/config/product/:id" component={ViewProduct} />
                        <Route path="/dashboard/config/new/product" component={CreateProduct} />

                        {/* SERVIÇOS */}
                        <Route exact path="/dashboard/config/services" component={ViewAllServices} />
                        <Route path="/dashboard/config/services/categories" component={ServiceCategories} />
                        <Route path="/dashboard/config/services/new" component={ServiceForm} />
                        <Route path="/dashboard/config/services/:id/edit" component={ServiceForm} />

                        {/* VENDAS */}
                        <Route path="/dashboard/orders" component={Vendas} />
                        <Route path="/dashboard/detailsorder/:id" component={DetalheVenda} />

                        {/* Vendas (Sales Orders) */}
                        <Route exact path="/dashboard/sales" component={ViewAllSalesOrders} />
                        <Route path="/dashboard/sales/new" component={CreateSalesOrder} />
                        <Route exact path="/dashboard/sales/quotes" component={ViewAllSalesQuotes} />
                        <Route path="/dashboard/sales/quotes/new" component={CreateSalesQuote} />
                        <Route path="/dashboard/sales/quotes/:id" component={ViewSalesQuote} />
                        <Route path="/dashboard/sales/price-tables" component={PriceTables} />
                        <Route path="/dashboard/sales/:id" component={ViewSalesOrder} />

                        {/* Compras (Purchase Orders) */}
                        <Route exact path="/dashboard/purchasing" component={ViewAllPurchaseOrders} />
                        <Route path="/dashboard/purchasing/new" component={CreatePurchaseOrder} />
                        <Route exact path="/dashboard/purchasing/requests" component={ViewAllPurchaseRequests} />
                        <Route path="/dashboard/purchasing/requests/new" component={CreatePurchaseRequest} />
                        <Route path="/dashboard/purchasing/requests/:id" component={ViewPurchaseRequest} />
                        <Route path="/dashboard/purchasing/quotations/:id" component={ViewPurchaseQuotation} />
                        <Route path="/dashboard/purchasing/:id" component={ViewPurchaseOrder} />

                        {/* Estoque (Inventory) */}
                        <Route exact path="/dashboard/inventory" component={StockPosition} />
                        <Route path="/dashboard/inventory/movements" component={StockMovements} />
                        <Route path="/dashboard/inventory/new" component={CreateStockMovement} />
                        <Route path="/dashboard/inventory/transfers" component={StockTransfers} />
                        <Route path="/dashboard/inventory/warehouses" component={Warehouses} />
                        <Route path="/dashboard/inventory/warehouse-locations" component={WarehouseLocations} />
                        <Route path="/dashboard/inventory/lots-serials" component={LotsAndSerials} />
                        <Route path="/dashboard/inventory/kardex" component={Kardex} />

                        {/* Financeiro (Contas a Pagar/Receber) */}
                        <Route exact path="/dashboard/financial/payable" component={ViewAllAccountsPayable} />
                        <Route path="/dashboard/financial/payable/new" component={AccountPayableForm} />
                        <Route path="/dashboard/financial/payable/:id/edit" component={AccountPayableForm} />
                        <Route exact path="/dashboard/financial/receivable" component={ViewAllAccountsReceivable} />
                        <Route path="/dashboard/financial/receivable/new" component={AccountReceivableForm} />
                        <Route path="/dashboard/financial/receivable/:id/edit" component={AccountReceivableForm} />
                        <Route path="/dashboard/financial/cashflow" component={CashFlow} />
                        <Route path="/dashboard/financial/bank-accounts" component={BankAccounts} />
                        <Route path="/dashboard/financial/reconciliation" component={BankReconciliation} />
                        <Route path="/dashboard/financial/collection-rules" component={CollectionRules} />
                        <Route exact path="/dashboard/financial" component={FinancialDashboard} />

                        {/* RH */}
                        <Route exact path="/dashboard/hr/colaboradores" component={ViewAllColaboradores} />
                        <Route path="/dashboard/hr/colaboradores/new" component={ColaboradorForm} />
                        <Route path="/dashboard/hr/colaboradores/:id/edit" component={ColaboradorForm} />
                        <Route path="/dashboard/hr/departments" component={Departments} />
                        <Route path="/dashboard/hr/roles" component={Roles} />
                        <Route path="/dashboard/hr/leave-requests" component={LeaveRequests} />
                        <Route exact path="/dashboard/hr/payroll" component={PayrollRuns} />
                        <Route path="/dashboard/hr/payroll/:id" component={PayrollRunDetail} />

                        {/* Linha de Produção */}
                        <Route exact path="/dashboard/production/bom" component={BillOfMaterialsList} />
                        <Route path="/dashboard/production/bom/new" component={CreateBillOfMaterials} />
                        <Route exact path="/dashboard/production/orders" component={ProductionOrders} />
                        <Route path="/dashboard/production/orders/:id" component={ProductionOrderDetail} />

                        {/* Relatórios */}
                        <Route exact path="/dashboard/reports" component={ReportsHome} />
                        <Route path="/dashboard/reports/sales" component={SalesReport} />
                        <Route path="/dashboard/reports/purchasing" component={PurchasingReport} />
                        <Route path="/dashboard/reports/financial-aging" component={FinancialAgingReport} />
                        <Route path="/dashboard/reports/inventory-valuation" component={InventoryValuationReport} />

                        {/* Estabelecimentos - agora acessados a partir da tela da empresa (Empresas) */}
                        <Route path="/dashboard/establishments/new" component={EstablishmentForm} />
                        <Route path="/dashboard/establishments/:id/edit" component={EstablishmentForm} />

                        {/* Calendário */}
                        <Route path="/dashboard/config/calendar" component={CalendarPage} />

                        {/* Organization */}
                        <Route path="/dashboard/config/organizations/create" component={CreateOrganization} />
                        <Route path="/dashboard/config/organizations/view" component={ViewOrganization} />
                        <Route path="/dashboard/config/organizations/edit/:id" component={EditOrganization} />
                        <Route path="/dashboard/config/suppliers" component={ViewSuppliers} />

                        {/* Minha Empresa (Company/Branch - Etapa 0.1) */}
                        <Route path="/dashboard/config/companies/create" component={CreateCompany} />
                        <Route path="/dashboard/config/companies/view" component={ViewCompanies} />
                        <Route path="/dashboard/config/companies/edit/:id" component={EditCompany} />
                        <Route path="/dashboard/config/companies/branches/new" component={BranchForm} />
                        <Route path="/dashboard/config/companies/branches/:id/edit" component={BranchForm} />

                        {/* Cadastros Auxiliares (Etapa 1 - Estruturas auxiliares) */}
                        <Route exact path="/dashboard/config/references" component={ReferencesHome} />
                        <Route path="/dashboard/config/references/units" component={UnitsOfMeasure} />
                        <Route path="/dashboard/config/references/currencies" component={Currencies} />
                        <Route path="/dashboard/config/references/banks" component={Banks} />
                        <Route path="/dashboard/config/references/bank-agencies" component={Agencies} />
                        <Route path="/dashboard/config/references/payment-methods" component={PaymentMethods} />
                        <Route path="/dashboard/config/references/payment-terms" component={PaymentTerms} />
                        <Route path="/dashboard/config/references/cost-centers" component={CostCenters} />
                        <Route path="/dashboard/config/references/financial-categories" component={FinancialCategories} />
                        <Route exact path="/dashboard/config/references/geography/countries" component={Countries} />
                        <Route path="/dashboard/config/references/geography/countries/:countryId/states" component={States} />
                        <Route path="/dashboard/config/references/geography/states/:stateId/cities" component={Cities} />

                        {/* Users */}

                        <Route path="/dashboard/admin/users" component={SystemUsers} />
                        <Route path="/dashboard/config/users/view/" component={ViewUsers} />
                        <Route path="/dashboard/config/users/create/" component={CreateUser} />
                        <Route path="/dashboard/config/users/edit/:id" component={EditUser} />

                        {/* Relatórios */}
                        <Route path="/utils/util-report" component={Reports} />

                        <Route path="/dashboard/config/index/" component={SettingsControl} />

                        {/* Customization */}
                        <Route path="/dashboard/config/custom/" component={Customizacao} />
                        <Route path="/dashboard/config/custom-fields" component={CustomFields} />
                        <Route path="/sample-page" component={SamplePage} />

                    </AuthGuard>
                </Switch>
            </MainLayout>
        </Route>
    );
};

export default MainRoutes;
